export const GIFT_PRODUCT_SORT_TYPE = {
  LATEST: 'LATEST',
  POPULAR: 'POPULAR',
  REVIEW_COUNT: 'REVIEW_COUNT',
} as const;

export const GIFT_PRODUCT_SORT_TYPE_LABEL = {
  [GIFT_PRODUCT_SORT_TYPE.LATEST]: '최근등록순',
  [GIFT_PRODUCT_SORT_TYPE.POPULAR]: '인기순',
  [GIFT_PRODUCT_SORT_TYPE.REVIEW_COUNT]: '후기 많은순',
} as const;

export const INITIAL_PAGE = 1;
export const INITIAL_SIZE = 1;

/**
 * count: 한 블럭에 표시할 상품 개수
 * cols: 행 당 열 개수
 */
export const PRODUCTS_PER_BLOCK = {
  DESKTOP: {
    count: 8,
    cols: 4,
  },
  TABLET: {
    count: 6,
    cols: 3,
  },
  MOBILE: {
    count: 4,
    cols: 2,
  },
} as const;
export const REVIEWS_PER_BLOCK = {
  DESKTOP: {
    count: 2,
    cols: 2,
  },
  TABLET: {
    count: 1,
    cols: 1,
  },
  MOBILE: {
    count: 1,
    cols: 1,
  },
} as const;
